"use client";

import type { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

export const surveyMonkeyInputs = [
  {
    name: "scriptUrl",
    friendlyName: "Survey Monkey Url",
    type: "url",
    required: true,
  },
] as const satisfies Inputs;

export const SurveyMonkeyComponent: RegisteredComponent = {
  name: "SurveyMonkey",
  component: dynamic(async () =>
    withValidation(surveyMonkeyInputs, (await import("./SurveyMonkey")).SurveyMonkey, "SurveyMonkey")
  ),
  inputs: surveyMonkeyInputs,
};
